import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router object
import 'bootstrap/dist/css/bootstrap.css';
import './assets/custom.css';
import 'bootstrap/dist/js/bootstrap.bundle';

const app = createApp(App);
app.use(router); // Use the router
app.mount('#app');
